import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '@/views/Home.vue')
  },
  {
    path: '/fittings',
    name: 'Fittings',
    component: () => import(/* webpackChunkName: "fittings" */ '@/views/Fittings.vue')
  },
    {
      path: '/skill-plans',
      name: 'SkillPlans',
      component: () => import(/* webpackChunkName: "skillplans" */ '@/views/SkillPlans.vue')
    },
    {
      path: '/links',
      name: 'Links',
      component: () => import(/* webpackChunkName: "links" */ '@/views/Links.vue')
    },
    {
      path: '/photos',
      name: 'Photos',
      component: () => import(/* webpackChunkName: "photos" */ '@/views/Photos.vue')
    },
    {
      path: '/about',
      name: 'About',
      component: () => import(/* webpackChunkName: "about" */ '@/views/About.vue')
    },
]

const router = new VueRouter({
  routes
})

export default router
